/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import React from "react";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import { InputWithErrorLabel, MaskedInputWithErrorLabel } from "components/haven-design/form/inputs";
import { US_PHONE_MASK } from "utils/phone";
import { createZipMask, StateSelect } from "../info";
import { propertyInfoSchema } from "../validation";
import NextButton from "./next-button";
import type { CommonStepProps } from "../step-props";

type Props = Pick<CommonStepProps, "formik" | "onNext">;

const StepPropertyInfo: React.FC<Props> = ({ formik, onNext }) => {
  const propertyInfoValues = formik.values.propertyInfo;
  const addressRequired = !propertyInfoValues.inDevelopment;
  const handleNext = (): void => {
    onNext();
  };
  const isValid = React.useMemo(() => {
    try {
      propertyInfoSchema.validateSync(propertyInfoValues, { abortEarly: false });
      return true;
    } catch {
      return false;
    }
  }, [propertyInfoValues]);


  return (
    <Grid size={{ xs: 12, md: 10, lg: 8 }} container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <InputWithErrorLabel
          name="propertyInfo.legalName"
          label="Property Legal Name"
          margin="none"
          size="medium"
          required
        />
      </Grid>
      <Grid size={{ xs: 8 }}>
        <MaskedInputWithErrorLabel
          name="propertyInfo.phone"
          label="Property Phone Number"
          margin="none"
          mask={US_PHONE_MASK}
          guide={false}
          size="medium"
          required
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputWithErrorLabel
          name="propertyInfo.phoneExtension"
          label="Extension"
          margin="none"
          size="medium"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <InputWithErrorLabel
          name="propertyInfo.address1"
          label="Property Address 1"
          margin="none"
          size="medium"
          required={addressRequired}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <InputWithErrorLabel
          name="propertyInfo.address2"
          label="Address 2"
          margin="none"
          size="medium"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <InputWithErrorLabel
          name="propertyInfo.city"
          label="City"
          margin="none"
          size="medium"
          required={addressRequired}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <StateSelect name="propertyInfo.state" label="State" margin="none" size="medium" required={addressRequired} />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <MaskedInputWithErrorLabel
          name="propertyInfo.zip"
          label="Zip"
          margin="none"
          mask={createZipMask()}
          guide={false}
          size="medium"
          required={addressRequired}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={propertyInfoValues.inDevelopment}
              onChange={(e) => formik.setFieldValue("propertyInfo.inDevelopment", e.target.checked)}
            />
          }
          label="Still in development"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <InputWithErrorLabel
          name="propertyInfo.email"
          label="Property Email"
          margin="normal"
          size="medium"
          required
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <NextButton
          onNext={handleNext}
          isValid={isValid}
        />
      </Grid>
    </Grid>
  );
};

export default StepPropertyInfo;


